import AddBank from './add-bank';

export default AddBank;
